// Framerate Calculator modal: opens the external tool (public/ccv5) in a large
// iframe modal. The trigger sits in the first HeroElement, the modal markup at
// page level. The iframe src is lazy-assigned on first open so the AngularJS
// app is not loaded until the user actually requests it.
document.addEventListener('DOMContentLoaded', () => {
    const modal = document.querySelector('[data-framerate-calculator-modal]');
    const openButton = document.querySelector('[data-behaviour="open-framerate-calculator"]');

    if (!modal || !openButton) return;

    const frame = modal.querySelector('.framerate-calculator-modal__frame');
    const closeTriggers = modal.querySelectorAll('[data-behaviour="close-framerate-calculator"]');

    const open = () => {
        // Assign the real src only once, on first open.
        if (frame && !frame.src && frame.dataset.src) {
            frame.src = frame.dataset.src;
        }

        modal.hidden = false;
        // Force reflow so the CSS transition runs when the class is added.
        void modal.offsetWidth;
        modal.classList.add('active');
        document.body.classList.add('framerate-calculator-modal--open');
    };

    const close = () => {
        modal.classList.remove('active');
        document.body.classList.remove('framerate-calculator-modal--open');

        const hide = () => {
            modal.hidden = true;
            modal.removeEventListener('transitionend', hide);
        };
        modal.addEventListener('transitionend', hide);
    };

    openButton.addEventListener('click', open);
    closeTriggers.forEach(trigger => trigger.addEventListener('click', close));

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('active')) {
            close();
        }
    });
});
